<template>
  <b-container
    @submit.prevent="login"
    class="frontend-style frontend-login-style"
    :style="{ 'background-image': `url(${this.Images.Home.banner.bg})` }"
  >
    <b-form>
      <b-form-group
        id="input-group-1"
        label="Account"
        label-for="input-1"
        description="請輸入網站操作人員帳號"
      >
        <b-form-input
          id="input-1"
          v-model="form.account"
          type="text"
          required
          placeholder="Enter Account"
        />
      </b-form-group>

      <b-form-group
        id="input-group-2"
        label="Password:"
        label-for="input-2"
      >
        <b-form-input
          id="input-2"
          v-model="form.password"
          type="password"
          required
          placeholder="Enter Password"
        />
      </b-form-group>

      <b-button
        type="submit"
        variant="primary"
        v-if="!operationState"
      >
        登入
      </b-button>
      <div v-else>
        <b-spinner
          variant="primary"
          label="Spinning"
        ></b-spinner>
        <p>loading...</p>
      </div>
    </b-form>
  </b-container>
</template>

<script>
  import { mapState, mapActions } from "vuex";

  export default {
    mounted() {
      this.$store.dispatch("backend/resetLoginState");
      this.$store.dispatch("backend/resetAdminState");
    },
    data() {
      return {
        form: {
          account: "",
          password: "",
        },
        operationState: false,
      };
    },
    methods: {
      ...mapActions("backend", ["approveLogin", "resetLoginState"]),
      ...mapActions("login", ["accountLogin"]),

      login: async function () {
        const { account, password } = this.form;
        this.operationState = true;
        const { state, error } = await this.accountLogin({
          email: account,
          password,
        });
        if (state) {
          this.$router.push({ name: "admin-home" });
        }
      },
    },
    computed: {
      ...mapState("backend", ["loginState"]),
      ...mapState("frontend", ["Images"]),
    },
    watch: {
      loginState() {
        if (this.loginState) {
          this.$router.push("admin");
        }
        if (!this.loginState && this.loginState !== null) {
          alert("帳號密碼有誤！");
          this.resetLoginState();
          this.operationState = false;
        }
      },
    },
  };
</script>
